import { AgGridFilterType, AgGridFilterTypeDto } from '../enums';

export const agGridFilterTypeMapDto: Record<string, AgGridFilterTypeDto> = {
  [AgGridFilterType.Text]: AgGridFilterTypeDto.Text,
  [AgGridFilterType.Number]: AgGridFilterTypeDto.Number,
  [AgGridFilterType.Date]: AgGridFilterTypeDto.Date,
  [AgGridFilterType.Dropdown]: AgGridFilterTypeDto.Multiselect,
};
